import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../environments/environment';
import { AppService } from '../../main/content/services/app.service';
import { Router } from '@angular/router';

//You can go through the advance Http configuration and functions from the Angular's 
//official documentation: https://angular.io/guide/http 
@Injectable()
export class AjaxService {
    headers: Headers = new Headers();
    apiBaseUrl: string = environment.apiUrl;
    apiUrl: string;


    constructor(private http: Http, public _router: Router, public appService: AppService,) { }
    private handleError(error: Response) {
        
        return Observable.throw(error);
    }
    public GET(endPoint) {
        this.headers.set('Authorization', sessionStorage.getItem('authToken'));
        if (endPoint == 'Component.svc/getComponentDetail/login') {
            this.headers.set('Domain', environment.domain);
            this.headers.set('SecretKey', environment.secretKey);
            this.headers.set('Cache-Control','no-cache');
            this.headers.set('Pragma','no-cache');
            this.headers.set('Expires',new Date().toString());
        }
        this.apiUrl = this.apiBaseUrl + endPoint;
        return this.http.get(this.apiUrl, { headers: this.headers })
        .map((res: Response) => {
            if(res.json()["Status"] == 0 && (res.json()["Message"] == "Session timout" || res.json()["Message"] == "errSession")){
                this.appService.timeOut();
            }
            else{
                return res.json();
            }            
        }).catch(this.handleError);   
    }

    public POST(endPoint, jsonData) {
        this.headers.set('Authorization', sessionStorage.getItem('authToken'));
        if (endPoint == 'User.svc/authenticate') {
            this.headers.set('Domain', environment.domain);
            this.headers.set('SecretKey', environment.secretKey);
        }
        this.headers.set('Content-Type', 'application/json');
        this.apiUrl = this.apiBaseUrl + endPoint;
        return this.http.post(this.apiUrl, jsonData, { headers: this.headers })
        .map((res: Response) => {
            if(res.json()["Status"] == 0 && (res.json()["Message"] == "Session timout" || res.json()["Message"] == "errSession")){
                this.appService.timeOut();
            }
            else{
                return res.json();
            }
        }).catch(this.handleError)
    }

    public PUT(endPoint, jsonData) {
        this.headers.set('Authorization', sessionStorage.getItem('authToken'));

        this.apiUrl = this.apiBaseUrl + endPoint;
        return this.http.put(this.apiUrl, jsonData, { headers: this.headers })
        .map((res: Response) => {
            if(res.json()["Status"] == 0 && (res.json()["Message"] == "Session timout" || res.json()["Message"] == "errSession")){
                this.appService.timeOut();
            }
            else{
                return res.json();
            }
        }).catch(this.handleError);    
    }

    public DELETE(endPoint) {
        this.headers.set('Authorization', sessionStorage.getItem('authToken'));
        this.apiUrl = this.apiBaseUrl + endPoint;
        return this.http.delete(this.apiUrl, { headers: this.headers })
        .map((res: Response) => {
            if(res.json()["Status"] == 0 && (res.json()["Message"] == "Session timout" || res.json()["Message"] == "errSession")){
                this.appService.timeOut();
            }
            else{
                return res.json();
            }
        }).catch(this.handleError);    
    }

    
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/core/services/ajax.service.ts